module.exports = __webpack_public_path__ + "img/palette-capture_jp.be7a61d.jpg";